<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 OS-m — Outros departamentos: Adição
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  criar uma OS-m informativa
        |  para
        strong  outro departamento
        | , a partir de
        strong  OS-m → Outros Departamentos
        | .

      .toast.toast-primary
        | A criação exige a permissão
        strong  Compartilhado → Ordem serviços → Criar
        | .

      h5.h5 1. Abrir a lista de assuntos
      ol
        li Em
          strong  OS-m → Outros Departamentos
          | , clique no botão
          code  +
          |  (
          em Nova OS-m
          | ).
        li O sistema abre a tela de
          strong  assuntos de outros departamentos
          |  disponíveis para criar OS-m informativa.

      h5.h5 2. Escolher o assunto
      figure.manual-figure
        img(:src="imgAssuntos" alt="Lista de assuntos de outros departamentos")
      ol
        li Use o campo
          strong  Pesquisar
          |  para filtrar por descrição, secretaria ou departamento.
        li Em cada card você vê o assunto e a hierarquia (secretaria, diretoria e departamento).
        li Clique em
          strong  Nova OS-m
          |  no card desejado.

      h5.h5 3. Preencher o formulário
      figure.manual-figure
        img(:src="imgNova" alt="Formulário Nova OS-m para outro departamento")
      p A tela
        strong  Nova OS-m para outro departamento
        |  traz:
      ol
        li
          strong Assunto
          |  — fixo, conforme o card escolhido (somente leitura).
        li
          strong Observações
          |  — obrigatório (texto da OS informativa).
        li
          strong Cadastro
          |  — opcional.
        li
          strong Protocolo
          |  — tipo, número, ano e data (opcional).

      h5.h5 4. Salvar
      ol
        li Clique em
          strong  Salvar
          |  (habilitado quando o formulário estiver válido).
        li O sistema confirma o sucesso e abre a OS criada na tela de exibição.

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgAssuntos: require("@/assets/manuais/09b-osm-outros-dept-assuntos.png"),
      imgNova: require("@/assets/manuais/09c-osm-outros-dept-nova.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
